import React from 'react';

/**
 * Circular / square icon-only button. Three tones; sized for touch.
 */
export function IconButton({
  children,
  variant = 'soft',
  size = 44,
  round = true,
  label,
  style = {},
  ...rest
}) {
  const variants = {
    soft:    { background: 'var(--ld-surface-mid)', color: 'var(--ld-text-primary)', border: 'none', boxShadow: 'none' },
    primary: { background: 'var(--ld-primary)', color: 'var(--ld-text-on-primary)', border: 'none', boxShadow: 'var(--ld-shadow-button)' },
    ghost:   { background: 'transparent', color: 'var(--ld-text-secondary)', border: '1.5px solid var(--ld-border)', boxShadow: 'none' },
    bare:    { background: 'transparent', color: 'var(--ld-text-secondary)', border: 'none', boxShadow: 'none' },
  };
  const v = variants[variant] || variants.soft;
  return (
    <button
      aria-label={label}
      title={label}
      style={{
        width: size, height: size, minHeight: size,
        padding: 0,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: round ? 'var(--ld-radius-pill)' : 'var(--ld-radius-md)',
        cursor: 'pointer',
        transition: 'transform var(--ld-dur-instant) var(--ld-ease), background var(--ld-transition-fast), filter var(--ld-transition-fast)',
        ...v,
        ...style,
      }}
      onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.92)'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      {...rest}
    >
      {children}
    </button>
  );
}
